module.exports = __webpack_public_path__ + "img/center.dd1cdc6c.svg";